import { ThemeProvider } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { differenceInDays, format } from "date-fns";
import React, { Fragment, useEffect } from "react";
import { AuthContext } from "../../App";
import { Pagina } from "../template/Template";

import { downloadMissingDirectory } from "../../services/MissingDirectoryService";

import { Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import {
    DataGrid,
    GridFilterToolbarButton,
    GridToolbarContainer,
} from "@material-ui/data-grid";
import SaveAlt from "@mui/icons-material/SaveAlt";

import { Formik } from "formik";
import { Loading } from "../Loading";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ShowMessageBox } from "../ShowMessageBox";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import { clienteFindAllByUsuId } from "../../services/ClienteService";
import { listarMissingDirectory } from "../../services/ContainerService";
import { siteFindByUsuId } from "../../services/SiteService";

import { useStyles } from "../styles/StyleMissingDirectory";
import { theme } from "../styles/Theme";

import DateFnsUtils from "@date-io/date-fns";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import ptBR2 from "date-fns/locale/pt-BR";

var MS_PER_DAY = 60000 * 60 * 24;

let severity = "success";
let msg = "";

export default function SituacaoUpload() {
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);
    const [listCliente, setListCliente] = React.useState([]);
    const [listSite, setListSite] = React.useState([]);
    useEffect(async () => {
        const respCliente = await clienteFindAllByUsuId();
        const respSite = await siteFindByUsuId();
        setListCliente(respCliente.data);
        setListSite(respSite.data);
    }, []);


    const Content = () => {
        const [openSnackBar, setOpenSnackBar] = React.useState(false);
        const [listContainers, setListContainers] = React.useState([]);
        const [openLoading, setOpenLoading] = React.useState(false);


        const CustomToolbar = () => {
            return (
                <GridToolbarContainer style={{ justifyContent: "space-between" }}>
                    <GridFilterToolbarButton />
                </GridToolbarContainer>
            );
        };

        return (
            <Fragment>
                <Formik
                    initialValues={{
                        dataInicial: new Date(new Date().getTime() - 30 * MS_PER_DAY),
                        dataFinal: new Date(),
                        sitId: "",
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);
                        if (values.sitId.trim().length == 0) {
                            severity = "error";
                            msg = "Selecione um site valido";
                            setOpenSnackBar(true);
                            return;
                        }
                        const diffInDays = differenceInDays(
                            values.dataFinal,
                            values.dataInicial
                        );
                        let dtif;
                        let dtff;

                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            return;
                        } else if (diffInDays > 365) {
                            severity = "error";
                            msg = "Ops, intervalos maiores que 365 dias não são permitidos";
                            setOpenSnackBar(true);
                            return;
                        }

                        dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                        dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                        setOpenLoading(true);
                        const list = await listarMissingDirectory(
                            values.sitId,
                            dtif,
                            dtff
                        );

                        setListContainers(list.data);
                        setOpenLoading(false);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form
                            onSubmit={handleSubmit}
                            className={classes.form}
                            style={{ display: "flex" }}
                        >
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <Loading open={openLoading} />

                                    <div className={classes.dashboard_header}>
                                        <div className={classes.dashboard_header_status}>
                                            <div className={classes.center_data}>
                                                <FormControl className={classes.site}>
                                                    <InputLabel id="label-site">Site</InputLabel>
                                                    <Select
                                                        labelId="label-site"
                                                        id="sitId"
                                                        name="sitId"
                                                        value={values.sitId}
                                                        className={classes.cliId}
                                                        //autoWidth
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem key="" value="">
                                                            Nenhum...
                                                        </MenuItem>

                                                        {listSite.map((site) => (
                                                            <MenuItem
                                                                key={site.sit_id}
                                                                value={site.sit_id}
                                                            >
                                                                {site.sit_nome}({site.sit_id})
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                <MuiPickersUtilsProvider
                                                    locale={ptBR2}
                                                    utils={DateFnsUtils}
                                                >
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        format="dd/MM/yyyy"
                                                        id="dataInicial"
                                                        name="dataInicial"
                                                        value={values.dataInicial}
                                                        onChange={(val) => {
                                                            setFieldValue("dataInicial", val);
                                                            //const dataFim = addDays(val, 7);
                                                            //setFieldValue("dataFinal", dataFim);
                                                        }}
                                                        onBlur={handleBlur}
                                                        style={{ width: "150px", marginRight: "30px" }}
                                                        KeyboardButtonProps={{
                                                            "aria-label": "change date",
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                                <MuiPickersUtilsProvider
                                                    locale={ptBR2}
                                                    utils={DateFnsUtils}
                                                >
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        format="dd/MM/yyyy"
                                                        value={values.dataFinal}
                                                        style={{ width: "150px", marginRight: "30px" }}
                                                        id="dataFinal"
                                                        name="dataFinal"
                                                        onChange={(val) => {
                                                            setFieldValue("dataFinal", val);
                                                            //const dataInicio = addDays(val, -7);
                                                            //setFieldValue("dataInicial", dataInicio);
                                                        }}
                                                        onBlur={handleBlur}
                                                        KeyboardButtonProps={{
                                                            "aria-label": "change date",
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        </div>
                                        <div className={classes.center_data}>
                                            <div className={classes.dashboard_header_filtro}>

                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    type="submit"
                                                    style={{ fontWeight: "bold" }}
                                                >
                                                    <FilterAltIcon />
                                                </Button>
                                                <Tooltip title="Exportar para Excel">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            if (values.sitId.trim().length == 0) {
                                                                severity = "error";
                                                                msg = "Selecione um site valido";
                                                                setOpenSnackBar(true);
                                                                return;
                                                            }
                                                            const diffInDays = differenceInDays(
                                                                values.dataFinal,
                                                                values.dataInicial
                                                            );
                                                            let dtif;
                                                            let dtff;

                                                            if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                                                                severity = "error";
                                                                msg = "Data inicial maior que data final";
                                                                setOpenSnackBar(true);
                                                                return;
                                                            } else if (diffInDays > 365) {
                                                                severity = "error";
                                                                msg = "Ops, intervalos maiores que 365 dias não são permitidos";
                                                                setOpenSnackBar(true);
                                                                return;
                                                            }

                                                            dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                                                            dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";


                                                            downloadMissingDirectory(values.sitId, dtif, dtff);
                                                        }}
                                                        disabled={listContainers.length === 0}
                                                        style={{ fontWeight: "bold", marginLeft: "10px" }}
                                                        Tooltip="Gerar a planilha xlsx"
                                                    >
                                                        <SaveAlt />
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.boxDataGrid}>
                                            <ThemeProvider theme={theme}>
                                                <DataGrid
                                                    rows={listContainers}
                                                    disableColumnMenu
                                                    hin
                                                    rowHeight={40}
                                                    disableColumnReorder
                                                    id="id"
                                                    components={{
                                                        Toolbar: CustomToolbar,
                                                    }}
                                                    columns={[
                                                        {
                                                            field: "mid_source_directory",
                                                            headerName: "Source Directory",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 350,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "mid_filename",
                                                            headerName: "Diretorio",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 250,
                                                            sortable: false,
                                                        },
                                                        {
                                                            field: "mid_origem",
                                                            headerName: "Origem",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 170,
                                                            sortable: false,
                                                            valueFormatter: (params) => params.value === "C" ? "Cliente" : params.value === "E" ? "Ebco" : "NF",
                                                        },
                                                        {
                                                            field: "created_at",
                                                            headerName: "Criado",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            }
                                                        },
                                                        {
                                                            field: "updated_at",
                                                            headerName: "Atualizado",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            }
                                                        },
                                                        {
                                                            field: "finished_at",
                                                            headerName: "Concluido",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            width: 150,
                                                            sortable: false,
                                                            align: "center",
                                                            valueFormatter: (params) => {
                                                                if (!(params.value == null)) {
                                                                    return format(
                                                                        new Date(params.value),
                                                                        "dd/MM/yy-HH:mm"
                                                                    );
                                                                }
                                                                return undefined;
                                                            }
                                                        },
                                                        {
                                                            field: "mid_message",
                                                            headerName: "Mensagem",
                                                            headerClassName: "header_grid",
                                                            type: "string",
                                                            headerAlign: "center",
                                                            flex: 1,
                                                            sortable: false,
                                                        }
                                                    ]}
                                                />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina
                authState={authState}
                Content={Content}
                HeaderDesc="DIRETORIOS FALTANDO"
            />
        </Fragment>
    );
}
